export default {
  home: {
    hero: {
      title: 'Your Source for <bold>Japanese Chemicals</bold> and Minor Metals',
    },
    news: {
      eyebrow: 'Latest Updates',
      title: 'News',
      readMore: 'Read more',
    },
    chemicals: {
      eyebrow: 'Our Products',
      title: 'Chemical List',
      description:
        'We are a licensed chemical supplier that provides high-quality chemicals and minor metals to clients around the world. For more information about our products and international shipping services, please see our Chemical List page.',
      cta: 'Chemical List',
    },
    importExport: {
      eyebrow: 'Trade Knowledge',
      title: 'Import / Export Terms',
      description:
        'A glossary of essential export and import terms with clear, easy-to-understand explanations designed to help you quickly understand common terminology used in international trade and logistics.',
      cta: 'Terms Glossary',
    },
    purchaseProcess: {
      eyebrow: 'How We Work',
      title: 'Purchase Process',
      description:
        'From your initial inquiry to product delivery, we guide you through a clear process, starting with clarifying your order specifications. Once confirmed, we proceed with the initial contract and shipment according to the agreed terms.',
      cta: 'Full Process',
    },
    newsItems: [
      { id: 'scholarship-repayment-2024', title: 'Introduced Scholarship Loan Repayment Support Program', date: 'Aug. 15, 2024' },
      { id: 'relocation-chuo-2023', title: 'We Relocated to Chuo-ku, Osaka', date: 'Jun. 5, 2023' },
      { id: 'trade-terminology-2015', title: 'Trade Terms Glossary Page Launched', date: 'Apr. 1, 2023' },
    ],
  },
};
